import { useIsMutating } from '@gogame/query';

import {
  mutations,
  mutationsPostback,
  mutationsConversion,
} from './queryKeyFactory';

export const useIsUpdating = () => useIsMutating(mutations.getPath()) > 0;

export const useIsUpdatingPostback = () =>
  useIsMutating(mutationsPostback.getPath()) > 0;

export const useIsUpdatingConversion = () =>
  useIsMutating(mutationsConversion.getPath()) > 0;
